import { render, staticRenderFns } from "./KonzessionsThemenCard.vue?vue&type=template&id=bf743e04&scoped=true&"
import script from "./KonzessionsThemenCard.vue?vue&type=script&lang=js&"
export * from "./KonzessionsThemenCard.vue?vue&type=script&lang=js&"
import style0 from "./KonzessionsThemenCard.vue?vue&type=style&index=0&id=bf743e04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf743e04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VIcon})
